import React, { Component } from 'react';
import Icon from '../components/Icon';

class Answer extends Component{
    render(){
        var inputId = "isg_question_" + this.props.questionIndex + "_answer_" + this.props.index;
        return (
            <li id={"isg_question_" + this.props.questionIndex + "_elem_" + this.props.index}>
              <input
                  type="radio"
                  name={"isg_question_" + this.props.questionIndex}
                  id={inputId}
                  value={this.props.index}
                  onChange={this.props.handleAnswerSelected}
                  disabled={!this.props.enabled}
                  checked={this.props.selected}
              />
              <label htmlFor={inputId}>
                <span className="isg_question_icon isg_question_icon_selected"><Icon value="icon_btn_on" /></span>
                <span className="isg_question_icon isg_question_icon_default"><Icon value="icon_btn_off" /></span>
                {this.props.answer}
              </label>
            </li>
        );
    }
}

Answer.propTypes = {
    answer: React.PropTypes.string.isRequired,
    index: React.PropTypes.number.isRequired,
    questionIndex: React.PropTypes.number.isRequired,
    handleAnswerSelected: React.PropTypes.func.isRequired,
    enabled: React.PropTypes.bool.isRequired,
    selected: React.PropTypes.bool.isRequired
};

export default Answer;


/** WEBPACK FOOTER **
 ** ./src/components/Answer.js
 **/